import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: c, color: l, withColor: i, removeClassName: t, disableSSR: h, style: o, ...m }) => {
  const p = o ? { ...d, ...o } : d;
  return /* @__PURE__ */ a.createElement(v, { disableSSR: h }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-chuangjianjiqiren", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (c ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-åå»ºæºå¨äºº"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: i ? r(l, 0, "#262933") : "#262933",
        datafollowfill: i ? r(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.1 11A6.9 6.9 0 0 1 11 4.1h10a6.9 6.9 0 0 1 6.9 6.9v3.5a.9.9 0 1 1-1.8 0V11A5.1 5.1 0 0 0 21 5.9H11A5.1 5.1 0 0 0 5.9 11v11a4.1 4.1 0 0 0 4.1 4.1h5a.9.9 0 1 1 0 1.8h-5A5.9 5.9 0 0 1 4.1 22V11Zm20.25 10.34a.85.85 0 1 0-1.7 0v.79h-.83a.85.85 0 1 0 0 1.7h.83v.87a.85.85 0 0 0 1.7 0v-.87h.83a.85.85 0 0 0 0-1.7h-.83v-.79Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M10.4 10c.497 0 .9.336.9.75v2.115c0 .415-.403.75-.9.75s-.9-.335-.9-.75V10.75c0-.414.403-.75.9-.75Zm7.122.75c0-.414-.403-.75-.9-.75s-.9.336-.9.75v2.115c0 .415.403.75.9.75s.9-.335.9-.75V10.75Zm-.385 5.503a.8.8 0 1 0-1.333-.886c-.56.842-1.312 1.011-2.002.966a3.78 3.78 0 0 1-1.26-.316l-.013-.006h.002l-.357.717.357-.716a.8.8 0 0 0-.714 1.432l.355-.712-.355.712h.001l.002.001.004.002.011.006.017.008.018.008.115.05a5.377 5.377 0 0 0 1.713.41c1.075.07 2.47-.22 3.439-1.677Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M23.5 18.9a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2ZM17.6 23a5.9 5.9 0 1 1 11.8 0 5.9 5.9 0 0 1-11.8 0Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, E = x;
export {
  E as default
};
